module.exports = require("./sr.d.ts");